// Share of the people reached who interacted, as a percentage.
export function engagementRate(
  interactions: null | number | undefined,
  reach: null | number | undefined,
): null | number {
  if (interactions === null || interactions === undefined || !reach)
    return null;

  return (interactions / reach) * 100;
}
